"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/**
 * 此插件用于开启行选择
 */
var react_1 = tslib_1.__importDefault(require("react"));
var InternalCheckbox_1 = require("../../Checkbox/InternalCheckbox");
var Radio_1 = require("../../Radio");
var utils_1 = require("../../utils");
var hooks_1 = require("../hooks");
// 这里只作为事件的触发器，不负责状态的加工处理
function SelectBox(props) {
    var indeterminate = props.indeterminate, onChange = props.onChange, position = props.position, rest = tslib_1.__rest(props, ["indeterminate", "onChange", "position"]);
    var selectionType = hooks_1.useTable().selectionType;
    function handleChange(value) {
        onChange === null || onChange === void 0 ? void 0 : onChange({ target: { checked: value } });
    }
    if (selectionType === 'single') {
        if (position === 'header') {
            return null;
        }
        return react_1.default.createElement(Radio_1.Radio, tslib_1.__assign({ onChange: handleChange }, rest));
    }
    return (react_1.default.createElement(InternalCheckbox_1.InternalCheckbox, tslib_1.__assign({ partialChecked: indeterminate, onChange: handleChange }, rest)));
}
function withSelectionColumn(hooks) {
    hooks.columns.push(function (columns) { return tslib_1.__spreadArrays([
        {
            id: 'selection',
            // eslint-disable-next-line react/display-name, @typescript-eslint/naming-convention
            Header: function (_a) {
                var getToggleAllRowsSelectedProps = _a.getToggleAllRowsSelectedProps;
                var tablePrefix = hooks_1.useTable().prefix;
                return (react_1.default.createElement("th", { className: utils_1.concat(tablePrefix, 'header', 'selection') },
                    react_1.default.createElement(SelectBox, tslib_1.__assign({ position: "header" }, getToggleAllRowsSelectedProps()))));
            },
            // eslint-disable-next-line react/display-name, @typescript-eslint/naming-convention
            Cell: function (_a) {
                var row = _a.row;
                var tablePrefix = hooks_1.useTable().prefix;
                return (react_1.default.createElement("td", { className: utils_1.concat(tablePrefix, 'body', 'selection') },
                    react_1.default.createElement(SelectBox, tslib_1.__assign({ position: "cell" }, row.getToggleRowSelectedProps()))));
            }
        }
    ], columns); });
}
exports.default = withSelectionColumn;
//# sourceMappingURL=withSelectionColumn.js.map